<template>
  <div class="dashboard-stats">
    <!-- Loading -->
    <div v-if="carregando" class="loading-container">
      <div class="spinner"></div>
      <p>Carregando estatísticas...</p>
    </div>

    <!-- Conteúdo -->
    <div v-else>
      <!-- Cards de KPIs -->
      <div class="kpi-cards">
        <div class="kpi-card">
          <div class="kpi-icon">👥</div>
          <div class="kpi-content">
            <span class="kpi-valor">{{ stats.totais?.total || 0 }}</span>
            <span class="kpi-label">Total de Pacientes</span>
          </div>
        </div>

        <div class="kpi-card">
          <div class="kpi-icon">📅</div>
          <div class="kpi-content">
            <span class="kpi-valor">{{ stats.totais?.mes_atual || 0 }}</span>
            <span class="kpi-label">Novos este Mês</span>
          </div>
        </div>

        <div class="kpi-card">
          <div class="kpi-icon">📆</div>
          <div class="kpi-content">
            <span class="kpi-valor">{{ stats.totais?.semana_atual || 0 }}</span>
            <span class="kpi-label">Novos esta Semana</span>
          </div>
        </div>

        <div class="kpi-card">
          <div class="kpi-icon">⭐</div>
          <div class="kpi-content">
            <span class="kpi-valor kpi-texto">{{ stats.totais?.sistema_popular || 'N/A' }}</span>
            <span class="kpi-label">Sistema Mais Popular</span>
          </div>
        </div>
      </div>

      <!-- Cards de Comunicação -->
      <div class="kpi-cards kpi-cards-comunicacao">
        <div class="kpi-card kpi-email-sim">
          <div class="kpi-icon">📧</div>
          <div class="kpi-content">
            <span class="kpi-valor">{{ stats.comunicacao?.email_sim || 0 }}</span>
            <span class="kpi-label">Aceitam E-mail</span>
          </div>
        </div>

        <div class="kpi-card kpi-email-nao">
          <div class="kpi-icon">🚫</div>
          <div class="kpi-content">
            <span class="kpi-valor">{{ stats.comunicacao?.email_nao || 0 }}</span>
            <span class="kpi-label">Não Aceitam E-mail</span>
          </div>
        </div>

        <div class="kpi-card kpi-whatsapp-sim">
          <div class="kpi-icon">💬</div>
          <div class="kpi-content">
            <span class="kpi-valor">{{ stats.comunicacao?.whatsapp_sim || 0 }}</span>
            <span class="kpi-label">Aceitam WhatsApp</span>
          </div>
        </div>

        <div class="kpi-card kpi-whatsapp-nao">
          <div class="kpi-icon">🔇</div>
          <div class="kpi-content">
            <span class="kpi-valor">{{ stats.comunicacao?.whatsapp_nao || 0 }}</span>
            <span class="kpi-label">Não Aceitam WhatsApp</span>
          </div>
        </div>
      </div>

      <!-- Gráficos -->
      <div class="graficos-grid">
        <!-- Evolução Mensal -->
        <div class="grafico-card grafico-largo">
          <h3>Evolução Mensal (Últimos 12 meses)</h3>
          <div class="grafico-container">
            <canvas ref="chartEvolucao"></canvas>
          </div>
        </div>

        <!-- Por Sistema -->
        <div class="grafico-card">
          <h3>Pacientes por Sistema</h3>
          <div class="grafico-container">
            <canvas ref="chartSistema"></canvas>
          </div>
        </div>

        <!-- Por Sexo -->
        <div class="grafico-card">
          <h3>Distribuição por Sexo</h3>
          <div class="grafico-container">
            <canvas ref="chartSexo"></canvas>
          </div>
        </div>

        <!-- Por UF -->
        <div class="grafico-card">
          <h3>Top 10 Estados</h3>
          <div class="grafico-container">
            <canvas ref="chartUf"></canvas>
          </div>
        </div>

        <!-- Por Captação (Marketing) -->
        <div class="grafico-card">
          <h3>Origem / Captação</h3>
          <div class="grafico-container">
            <canvas ref="chartCaptacao"></canvas>
          </div>
        </div>

        <!-- Por Indicação Clínica -->
        <div class="grafico-card">
          <h3>Indicação Clínica</h3>
          <div class="grafico-container">
            <canvas ref="chartIndicacao"></canvas>
          </div>
        </div>
      </div>

      <!-- ============================================ -->
      <!-- SEÇÃO DE NOTIFICAÇÕES -->
      <!-- ============================================ -->
      <div class="secao-separador">
        <h2>📨 Estatísticas de Notificações</h2>
      </div>

      <!-- Loading Notificações -->
      <div v-if="carregandoNotificacoes" class="loading-container loading-small">
        <div class="spinner"></div>
        <p>Carregando estatísticas de notificações...</p>
      </div>

      <!-- KPIs de Notificações -->
      <div v-else class="kpi-cards kpi-cards-notificacoes">
        <div class="kpi-card kpi-notif-enviados">
          <div class="kpi-icon">📤</div>
          <div class="kpi-content">
            <span class="kpi-valor">{{ notifStats.total_enviados || 0 }}</span>
            <span class="kpi-label">Total Enviados</span>
          </div>
        </div>

        <div class="kpi-card kpi-notif-sucesso">
          <div class="kpi-icon">✅</div>
          <div class="kpi-content">
            <span class="kpi-valor">{{ notifStats.taxa_sucesso || 0 }}%</span>
            <span class="kpi-label">Taxa de Sucesso</span>
          </div>
        </div>

        <div class="kpi-card kpi-notif-falhas">
          <div class="kpi-icon">❌</div>
          <div class="kpi-content">
            <span class="kpi-valor">{{ notifStats.total_falhas || 0 }}</span>
            <span class="kpi-label">Total de Falhas</span>
          </div>
        </div>

        <div class="kpi-card kpi-notif-campanhas">
          <div class="kpi-icon">📋</div>
          <div class="kpi-content">
            <span class="kpi-valor">{{ notifStats.campanhas_stats?.total || 0 }}</span>
            <span class="kpi-label">Total de Campanhas</span>
          </div>
        </div>
      </div>

      <!-- Gráficos de Notificações -->
      <div v-if="!carregandoNotificacoes" class="graficos-grid">
        <!-- Evolução de Envios -->
        <div class="grafico-card grafico-largo">
          <h3>Evolução de Envios (Últimos 6 meses)</h3>
          <div class="grafico-container">
            <canvas ref="chartNotifEvolucao"></canvas>
            <div v-if="!temDadosEvolucao" class="sem-dados">
              <i class="fas fa-chart-line"></i>
              <p>Nenhum envio nos últimos 6 meses</p>
            </div>
          </div>
        </div>

        <!-- Por Canal -->
        <div class="grafico-card">
          <h3>Envios por Canal</h3>
          <div class="grafico-container">
            <canvas ref="chartNotifCanal"></canvas>
            <div v-if="!temDadosCanal" class="sem-dados">
              <i class="fas fa-chart-pie"></i>
              <p>Nenhum envio registrado</p>
            </div>
          </div>
        </div>

        <!-- Por Status -->
        <div class="grafico-card">
          <h3>Distribuição por Status</h3>
          <div class="grafico-container">
            <canvas ref="chartNotifStatus"></canvas>
            <div v-if="!temDadosStatus" class="sem-dados">
              <i class="fas fa-chart-bar"></i>
              <p>Nenhum envio registrado</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch, nextTick } from 'vue';
import axios from 'axios';
import {
  Chart,
  CategoryScale,
  LinearScale,
  BarController,
  BarElement,
  LineController,
  LineElement,
  PointElement,
  ArcElement,
  PieController,
  DoughnutController,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';

// Registrar componentes do Chart.js
Chart.register(
  CategoryScale,
  LinearScale,
  BarController,
  BarElement,
  LineController,
  LineElement,
  PointElement,
  ArcElement,
  PieController,
  DoughnutController,
  Title,
  Tooltip,
  Legend,
  Filler
);

const props = defineProps({
  isDarkMode: {
    type: Boolean,
    default: false
  }
});

const carregando = ref(true);
const carregandoNotificacoes = ref(true);
/** @type {import('vue').Ref<import('@/types/api').DashboardStatsResponse>} */
const stats = ref({});
const notifStats = ref({});

// Refs para os canvas dos gráficos de pacientes
const chartEvolucao = ref(null);
const chartSistema = ref(null);
const chartSexo = ref(null);
const chartUf = ref(null);
const chartCaptacao = ref(null);
const chartIndicacao = ref(null);

// Refs para os canvas dos gráficos de notificações
const chartNotifEvolucao = ref(null);
const chartNotifCanal = ref(null);
const chartNotifStatus = ref(null);

// Instâncias dos gráficos
let chartInstances = {
  evolucao: null,
  sistema: null,
  sexo: null,
  uf: null,
  captacao: null,
  indicacao: null,
  notifEvolucao: null,
  notifCanal: null,
  notifStatus: null
};

// Computed para verificar se há dados nos gráficos de notificações
const temDadosEvolucao = computed(() => {
  return notifStats.value?.envios_por_mes?.length > 0;
});

const temDadosCanal = computed(() => {
  if (!notifStats.value?.por_canal) return false;
  const canais = Object.keys(notifStats.value.por_canal);
  return canais.length > 0 && canais.some(c => notifStats.value.por_canal[c]?.total > 0);
});

const temDadosStatus = computed(() => {
  if (!notifStats.value?.por_status) return false;
  const statuses = Object.keys(notifStats.value.por_status);
  return statuses.length > 0 && statuses.some(s => notifStats.value.por_status[s]?.total > 0);
});

// Cores para os gráficos
const cores = [
  '#4caf50', '#2196f3', '#ff9800', '#e91e63',
  '#9c27b0', '#00bcd4', '#ff5722', '#607d8b',
  '#8bc34a', '#3f51b5'
];

const coresTransparentes = cores.map(c => c + '80');

// Carregar estatísticas de pacientes
const carregarStats = async () => {
  try {
    carregando.value = true;
    const response = await axios.get('/api/dashboard/stats');
    stats.value = response.data;
  } catch (error) {
    console.error('Erro ao carregar estatísticas:', error);
  } finally {
    carregando.value = false;
    // Aguardar DOM atualizar antes de renderizar gráficos
    await nextTick();
    setTimeout(() => {
      renderizarGraficos();
    }, 100);
  }
};

// Carregar estatísticas de notificações
const carregarNotifStats = async () => {
  try {
    carregandoNotificacoes.value = true;
    const response = await axios.get('/api/notificacoes/logs/stats');
    notifStats.value = response.data;
  } catch (error) {
    console.error('Erro ao carregar estatísticas de notificações:', error);
  } finally {
    carregandoNotificacoes.value = false;
    await nextTick();
    setTimeout(() => {
      renderizarGraficosNotificacoes();
    }, 100);
  }
};

// Destruir gráficos existentes
const destruirGraficos = () => {
  Object.values(chartInstances).forEach(chart => {
    if (chart) chart.destroy();
  });
};

// Cores baseadas no tema
const getCorTexto = () => props.isDarkMode ? '#e0e0e0' : '#333';
const getCorGrid = () => props.isDarkMode ? '#444' : '#ddd';

// Renderizar todos os gráficos
const renderizarGraficos = () => {
  destruirGraficos();

  // Gráfico de Evolução Mensal (Linha)
  if (chartEvolucao.value && stats.value.evolucao_mensal?.length) {
    const ctx = chartEvolucao.value.getContext('2d');
    chartInstances.evolucao = new Chart(ctx, {
      type: 'line',
      data: {
        labels: stats.value.evolucao_mensal.map(e => e.mes),
        datasets: [{
          label: 'Novos Pacientes',
          data: stats.value.evolucao_mensal.map(e => e.total),
          borderColor: '#4caf50',
          backgroundColor: 'rgba(76, 175, 80, 0.1)',
          fill: true,
          tension: 0.4,
          pointBackgroundColor: '#4caf50',
          pointBorderColor: '#fff',
          pointBorderWidth: 2,
          pointRadius: 5
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              title: (items) => {
                const idx = items[0].dataIndex;
                return stats.value.evolucao_mensal[idx].mes_completo;
              }
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: { color: getCorTexto() },
            grid: { color: getCorGrid() }
          },
          x: {
            ticks: { color: getCorTexto() },
            grid: { display: false }
          }
        }
      }
    });
  }

  // Gráfico por Sistema (Doughnut)
  if (chartSistema.value && stats.value.por_sistema?.length) {
    const ctx = chartSistema.value.getContext('2d');
    chartInstances.sistema = new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: stats.value.por_sistema.map(s => s.sistema),
        datasets: [{
          data: stats.value.por_sistema.map(s => s.total),
          backgroundColor: cores,
          borderColor: props.isDarkMode ? '#1e1e1e' : '#fff',
          borderWidth: 2
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'right',
            labels: { color: getCorTexto(), boxWidth: 12, padding: 8 }
          }
        }
      }
    });
  }

  // Gráfico por Sexo (Pie)
  if (chartSexo.value && stats.value.por_sexo?.length) {
    const ctx = chartSexo.value.getContext('2d');
    const coresSexo = ['#2196f3', '#e91e63', '#9c27b0', '#607d8b'];
    chartInstances.sexo = new Chart(ctx, {
      type: 'pie',
      data: {
        labels: stats.value.por_sexo.map(s => s.sexo),
        datasets: [{
          data: stats.value.por_sexo.map(s => s.total),
          backgroundColor: coresSexo,
          borderColor: props.isDarkMode ? '#1e1e1e' : '#fff',
          borderWidth: 2
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom',
            labels: { color: getCorTexto(), boxWidth: 12, padding: 8 }
          }
        }
      }
    });
  }

  // Gráfico por UF (Barras Horizontais)
  if (chartUf.value && stats.value.por_uf?.length) {
    const ctx = chartUf.value.getContext('2d');
    chartInstances.uf = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: stats.value.por_uf.map(u => u.uf),
        datasets: [{
          label: 'Pacientes',
          data: stats.value.por_uf.map(u => u.total),
          backgroundColor: coresTransparentes,
          borderColor: cores,
          borderWidth: 1
        }]
      },
      options: {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false }
        },
        scales: {
          x: {
            beginAtZero: true,
            ticks: { color: getCorTexto() },
            grid: { color: getCorGrid() }
          },
          y: {
            ticks: { color: getCorTexto() },
            grid: { display: false }
          }
        }
      }
    });
  }

  // Gráfico por Captação / Marketing (Barras Horizontais)
  if (chartCaptacao.value && stats.value.por_captacao?.length) {
    const ctx = chartCaptacao.value.getContext('2d');
    const coresCaptacao = ['#ff9800', '#ff5722', '#ffc107', '#ffeb3b', '#ff9800', '#ef6c00', '#f57c00', '#ffb300', '#ffa000', '#ff8f00'];
    chartInstances.captacao = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: stats.value.por_captacao.map(c => c.captacao),
        datasets: [{
          label: 'Pacientes',
          data: stats.value.por_captacao.map(c => c.total),
          backgroundColor: coresCaptacao.map(c => c + '80'),
          borderColor: coresCaptacao,
          borderWidth: 1
        }]
      },
      options: {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false }
        },
        scales: {
          x: {
            beginAtZero: true,
            ticks: { color: getCorTexto() },
            grid: { color: getCorGrid() }
          },
          y: {
            ticks: { color: getCorTexto() },
            grid: { display: false }
          }
        }
      }
    });
  }

  // Gráfico por Indicação Clínica (Barras Horizontais)
  if (chartIndicacao.value && stats.value.por_indicacao?.length) {
    const ctx = chartIndicacao.value.getContext('2d');
    const coresIndicacao = ['#9c27b0', '#673ab7', '#3f51b5', '#7c4dff', '#b388ff', '#ea80fc', '#e040fb', '#d500f9', '#aa00ff', '#7c4dff'];
    chartInstances.indicacao = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: stats.value.por_indicacao.map(i => i.indicacao),
        datasets: [{
          label: 'Pacientes',
          data: stats.value.por_indicacao.map(i => i.total),
          backgroundColor: coresIndicacao.map(c => c + '80'),
          borderColor: coresIndicacao,
          borderWidth: 1
        }]
      },
      options: {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false }
        },
        scales: {
          x: {
            beginAtZero: true,
            ticks: { color: getCorTexto() },
            grid: { color: getCorGrid() }
          },
          y: {
            ticks: { color: getCorTexto() },
            grid: { display: false }
          }
        }
      }
    });
  }
};

// Renderizar gráficos de notificações
const renderizarGraficosNotificacoes = () => {
  // Destruir gráficos de notificações existentes
  if (chartInstances.notifEvolucao) {
    chartInstances.notifEvolucao.destroy();
    chartInstances.notifEvolucao = null;
  }
  if (chartInstances.notifCanal) {
    chartInstances.notifCanal.destroy();
    chartInstances.notifCanal = null;
  }
  if (chartInstances.notifStatus) {
    chartInstances.notifStatus.destroy();
    chartInstances.notifStatus = null;
  }

  // Gráfico de Evolução de Envios (Linha)
  if (chartNotifEvolucao.value && temDadosEvolucao.value) {
    const ctx = chartNotifEvolucao.value.getContext('2d');
    chartInstances.notifEvolucao = new Chart(ctx, {
      type: 'line',
      data: {
        labels: notifStats.value.envios_por_mes.map(e => e.mes_curto),
        datasets: [
          {
            label: 'Sucesso',
            data: notifStats.value.envios_por_mes.map(e => e.sucesso || 0),
            borderColor: '#4caf50',
            backgroundColor: 'rgba(76, 175, 80, 0.1)',
            fill: true,
            tension: 0.4,
            pointBackgroundColor: '#4caf50',
            pointBorderColor: '#fff',
            pointBorderWidth: 2,
            pointRadius: 5
          },
          {
            label: 'Falhas',
            data: notifStats.value.envios_por_mes.map(e => e.falhas || 0),
            borderColor: '#f44336',
            backgroundColor: 'rgba(244, 67, 54, 0.1)',
            fill: true,
            tension: 0.4,
            pointBackgroundColor: '#f44336',
            pointBorderColor: '#fff',
            pointBorderWidth: 2,
            pointRadius: 5
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'top',
            labels: { color: getCorTexto(), boxWidth: 12, padding: 10 }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: { color: getCorTexto() },
            grid: { color: getCorGrid() }
          },
          x: {
            ticks: { color: getCorTexto() },
            grid: { display: false }
          }
        }
      }
    });
  }

  // Gráfico por Canal (Doughnut)
  if (chartNotifCanal.value && temDadosCanal.value) {
    const ctx = chartNotifCanal.value.getContext('2d');
    const emailTotal = notifStats.value.por_canal?.email?.total || 0;
    const whatsappTotal = notifStats.value.por_canal?.whatsapp?.total || 0;

    chartInstances.notifCanal = new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: ['E-mail', 'WhatsApp'],
        datasets: [{
          data: [emailTotal, whatsappTotal],
          backgroundColor: ['#2196f3', '#25d366'],
          borderColor: props.isDarkMode ? '#252525' : '#fff',
          borderWidth: 3
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutout: '60%',
        plugins: {
          legend: {
            position: 'bottom',
            labels: { color: getCorTexto(), boxWidth: 12, padding: 10 }
          }
        }
      }
    });
  }

  // Gráfico por Status (Barras Horizontais)
  if (chartNotifStatus.value && temDadosStatus.value) {
    const ctx = chartNotifStatus.value.getContext('2d');
    const statusConfig = [
      { key: 'entregue', label: 'Entregue', cor: '#4caf50' },
      { key: 'enviado', label: 'Enviado', cor: '#2196f3' },
      { key: 'pendente', label: 'Pendente', cor: '#ff9800' },
      { key: 'falha', label: 'Falha', cor: '#f44336' }
    ];

    const labels = [];
    const valores = [];
    const bgCores = [];

    statusConfig.forEach(s => {
      const total = notifStats.value.por_status?.[s.key]?.total || 0;
      if (total > 0) {
        labels.push(s.label);
        valores.push(total);
        bgCores.push(s.cor);
      }
    });

    if (valores.length > 0) {
      chartInstances.notifStatus = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: labels,
          datasets: [{
            data: valores,
            backgroundColor: bgCores.map(c => c + '80'),
            borderColor: bgCores,
            borderWidth: 1,
            borderRadius: 4
          }]
        },
        options: {
          indexAxis: 'y',
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false }
          },
          scales: {
            x: {
              beginAtZero: true,
              ticks: { color: getCorTexto() },
              grid: { color: getCorGrid() }
            },
            y: {
              ticks: { color: getCorTexto() },
              grid: { display: false }
            }
          }
        }
      });
    }
  }
};

// Watch para atualizar gráficos quando tema mudar
watch(() => props.isDarkMode, () => {
  if (!carregando.value) {
    renderizarGraficos();
  }
  if (!carregandoNotificacoes.value) {
    renderizarGraficosNotificacoes();
  }
});

onMounted(() => {
  carregarStats();
  carregarNotifStats();
});

// Expor método para recarregar
defineExpose({
  recarregar: carregarStats,
  recarregarNotificacoes: carregarNotifStats
});
</script>

<style scoped>
.dashboard-stats {
  padding: 10px;
}

/* Loading */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  gap: 15px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #ddd;
  border-top-color: #4caf50;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* KPI Cards */
.kpi-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-bottom: 20px;
}

.kpi-card {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 20px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s, box-shadow 0.2s;
}

.kpi-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.dark-mode .kpi-card {
  background: #252525;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.kpi-icon {
  font-size: 32px;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f7f0;
  border-radius: 10px;
}

.dark-mode .kpi-icon {
  background: #1b4332;
}

.kpi-content {
  display: flex;
  flex-direction: column;
}

.kpi-valor {
  font-size: 28px;
  font-weight: 700;
  color: #2c3e50;
  line-height: 1.2;
}

.kpi-valor.kpi-texto {
  font-size: 16px;
  font-weight: 600;
}

.dark-mode .kpi-valor {
  color: #e0e0e0;
}

.kpi-label {
  font-size: 13px;
  color: #666;
  margin-top: 2px;
}

.dark-mode .kpi-label {
  color: #aaa;
}

/* Cards de Comunicação */
.kpi-cards-comunicacao {
  margin-bottom: 20px;
}

.kpi-email-sim .kpi-icon {
  background: #e3f2fd;
}
.dark-mode .kpi-email-sim .kpi-icon {
  background: #1565c0;
}

.kpi-email-nao .kpi-icon {
  background: #ffebee;
}
.dark-mode .kpi-email-nao .kpi-icon {
  background: #c62828;
}

.kpi-whatsapp-sim .kpi-icon {
  background: #e8f5e9;
}
.dark-mode .kpi-whatsapp-sim .kpi-icon {
  background: #2e7d32;
}

.kpi-whatsapp-nao .kpi-icon {
  background: #fff3e0;
}
.dark-mode .kpi-whatsapp-nao .kpi-icon {
  background: #e65100;
}

/* Gráficos */
.graficos-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}

.grafico-card {
  background: #fff;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.dark-mode .grafico-card {
  background: #252525;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.grafico-card h3 {
  margin: 0 0 15px 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.dark-mode .grafico-card h3 {
  color: #e0e0e0;
}

.grafico-largo {
  grid-column: span 2;
}

.grafico-container {
  height: 250px;
  position: relative;
}

.grafico-largo .grafico-container {
  height: 200px;
}

/* Responsivo */
@media (max-width: 900px) {
  .graficos-grid {
    grid-template-columns: 1fr;
  }

  .grafico-largo {
    grid-column: span 1;
  }
}

@media (max-width: 600px) {
  .dashboard-stats {
    padding: 5px;
  }

  .kpi-cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .kpi-card {
    padding: 12px;
    flex-direction: column;
    text-align: center;
    gap: 8px;
  }

  .kpi-icon {
    font-size: 24px;
    width: 40px;
    height: 40px;
  }

  .kpi-valor {
    font-size: 22px;
  }

  .kpi-valor.kpi-texto {
    font-size: 13px;
  }

  .kpi-label {
    font-size: 11px;
  }

  .grafico-card {
    padding: 12px;
  }

  .grafico-card h3 {
    font-size: 13px;
  }

  .grafico-container {
    height: 200px;
  }

  .grafico-largo .grafico-container {
    height: 180px;
  }
}

/* ============================================ */
/* SEÇÃO DE NOTIFICAÇÕES */
/* ============================================ */
.secao-separador {
  margin: 40px 0 20px;
  padding: 15px 0;
  border-top: 2px solid #e0e0e0;
}

.secao-separador h2 {
  margin: 0;
  font-size: 1.4rem;
  font-weight: 600;
  color: #333;
}

.dark-mode .secao-separador {
  border-top-color: #444;
}

.dark-mode .secao-separador h2 {
  color: #e0e0e0;
}

.loading-small {
  min-height: 150px;
}

/* KPIs de Notificações */
.kpi-cards-notificacoes {
  margin-bottom: 20px;
}

.kpi-notif-enviados {
  border-left: 4px solid #2196f3;
}

.kpi-notif-sucesso {
  border-left: 4px solid #4caf50;
}

.kpi-notif-falhas {
  border-left: 4px solid #f44336;
}

.kpi-notif-campanhas {
  border-left: 4px solid #ff9800;
}

/* Mensagem sem dados */
.sem-dados {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #999;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
}

.dark-mode .sem-dados {
  background: rgba(37, 37, 37, 0.9);
  color: #666;
}

.sem-dados i {
  font-size: 32px;
  margin-bottom: 10px;
  opacity: 0.5;
}

.sem-dados p {
  margin: 0;
  font-size: 13px;
}
</style>
